import * as stylex from "@stylexjs/stylex";
import { spacing } from "@softmax/design-system/tokens.stylex";

export const communityPageStyles = stylex.create({
  page: {
    width: "100%",
    maxWidth: 1200,
    minHeight: "60vh",
    marginInline: "auto",
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 768px)": spacing.space48,
    },
    paddingBlock: spacing.space48,
  },
  placeholder: {
    display: "grid",
    gap: spacing.space32,
    maxWidth: 800,
  },
});
